export default "__VITE_ASSET__BE42M9P3__"